import React, { useState } from 'react';
import './TabComponent.scss';

const TabComponent = ({ tabs, defaultTab = 0 }) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div className='tab-component'>
      <div className='tab-header'>
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab-button ${activeTab === index ? 'active' : ''}`}
            onClick={() => handleTabClick(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className='tab-content'>{tabs[activeTab]?.content}</div>
    </div>
  );
};

export default TabComponent;
